// extracted by mini-css-extract-plugin
module.exports = {"website":"Website_website__1hgEa"};